'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iconButton = require('../icon-button');

var _iconButton2 = _interopRequireDefault(_iconButton);

var _checkbox = require('../checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _contextMenu = require('../context-menu');

require('./filter.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = function (_React$Component) {
  _inherits(Filter, _React$Component);

  function Filter(props) {
    _classCallCheck(this, Filter);

    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

    _this.state = {
      areAllFiltersSelected: false
    };

    _this.handleInitialRender = _this.handleInitialRender.bind(_this);
    return _this;
  }

  _createClass(Filter, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.handleInitialRender(this.props.options);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.handleInitialRender(nextProps.options);
    }
  }, {
    key: 'handleInitialRender',
    value: function handleInitialRender(options) {
      var areAllFiltersSelected = options.every(function (option) {
        return option.checked;
      });

      this.setState({ areAllFiltersSelected: areAllFiltersSelected });
    }
  }, {
    key: 'handleFilterSelection',
    value: function handleFilterSelection(option) {
      var options = this.props.options.map(function (opt) {
        var modifiedOption = _extends({}, opt);
        if (modifiedOption.id === option.id) {
          modifiedOption.checked = !option.checked;
        }
        return modifiedOption;
      });

      this.fireOnChange(options);
    }
  }, {
    key: 'fireOnChange',
    value: function fireOnChange(options) {
      if (this.props.onChange) {
        this.props.onChange(options);
      }
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      var title = this.props.title;


      if (!title) {
        return null;
      }

      return _react2.default.createElement(
        _contextMenu.ContextMenuItem,
        { disabled: true, className: 'filter__title' },
        title
      );
    }
  }, {
    key: 'renderOptions',
    value: function renderOptions() {
      var _this2 = this;

      return this.props.options.map(function (option, index) {
        return _react2.default.createElement(
          _react2.default.Fragment,
          { key: 'fragment-' + index },
          _this2.renderGroupTitle(option, index),
          _react2.default.createElement(
            _contextMenu.ContextMenuItem,
            {
              key: 'item-' + index,
              onClick: function onClick(event) {
                event.stopPropagation();
                _this2.handleFilterSelection(option);
              }
            },
            _react2.default.createElement(
              _checkbox2.default,
              {
                key: option.label,
                checked: option.checked,
                readOnly: true,
                className: 'filter__checkbox'
              },
              option.label
            )
          )
        );
      });
    }
  }, {
    key: 'renderGroupTitle',
    value: function renderGroupTitle(option, index) {
      var _props = this.props,
          groupBy = _props.groupBy,
          options = _props.options;

      var previousGroup = options[index - 1] && options[index - 1][groupBy];
      var currentGroup = options[index] && options[index][groupBy];
      var isSameGroup = previousGroup === currentGroup;

      if (!this.props.groupBy || isSameGroup) {
        return null;
      }

      return _react2.default.createElement(
        _contextMenu.ContextMenuItem,
        { disabled: true, className: 'filter__group-title' },
        option[groupBy]
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          options = _props2.options,
          onChange = _props2.onChange,
          title = _props2.title,
          groupBy = _props2.groupBy,
          props = _objectWithoutProperties(_props2, ['options', 'onChange', 'title', 'groupBy']);

      return _react2.default.createElement(
        _contextMenu.ContextMenu,
        _extends({
          opener: _react2.default.createElement(_iconButton2.default, { icon: 'filter', shape: 'circle' }),
          className: 'filter'
        }, props),
        this.renderTitle(),
        this.renderOptions()
      );
    }
  }]);

  return Filter;
}(_react2.default.Component);

Filter.propTypes = {
  options: _propTypes2.default.array,
  onChange: _propTypes2.default.func,
  title: _propTypes2.default.string,
  groupBy: _propTypes2.default.string
};

Filter.defaultProps = {
  options: []
};

exports.default = Filter;